<template>
  <section class="apple-settings-connections" aria-label="设置中的 WebDAV 连接" :aria-busy="String(davLoading)">
    <p v-if="davLoading" class="apple-settings-connections-message" role="status">正在读取连接…</p>
    <div v-if="davLoadError" class="apple-settings-connections-load-error">
      <p role="alert">{{ davLoadError }}</p><AppleButton variant="subtle" :disabled="davLoading" @click="loadDavConnections">重试</AppleButton>
    </div>
    <div v-if="state.davConnections.length" class="apple-settings-connection-list">
      <article v-for="connection in state.davConnections" :key="connection.id" class="apple-settings-connection-card" :data-settings-dav-id="connection.id" :aria-label="connection.name">
        <header class="apple-settings-connection-heading">
          <span class="apple-settings-connection-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><rect x="6" y="3" width="12" height="18" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="M9 7h6M9 10h6M9 16h6M10 19h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></span>
          <div class="apple-settings-connection-copy"><h3 :title="connection.name">{{ connection.name }}</h3><p :title="connection.url">{{ connection.url }}</p></div>
          <span class="apple-settings-connection-state" :class="testState(connection).kind" data-settings-dav-test-state><i aria-hidden="true" />{{ testState(connection).label }}</span>
          <AppleButton variant="plain" icon-only class="apple-settings-connection-delete" :aria-label="'删除连接 ' + connection.name" :disabled="Boolean(davBusy[connection.id])" @click="removeDav(connection)"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 5h12M8 5V3h4v2M6 5l.7 12h6.6L14 5M8.5 8v6M11.5 8v6" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/></svg></AppleButton>
        </header>
        <div class="apple-settings-connection-actions">
          <AppleButton variant="subtle" :to="editorLocation(connection)" :disabled="Boolean(davBusy[connection.id])" :aria-label="'编辑连接 ' + connection.name">编辑</AppleButton>
          <AppleButton variant="subtle" :disabled="Boolean(davBusy[connection.id])" :aria-label="'测试连接 ' + connection.name" @click="testDav(connection)">{{ davBusy[connection.id] === 'test' ? '测试中…' : '测试' }}</AppleButton>
          <AppleButton variant="subtle" :disabled="Boolean(davBusy[connection.id])" :aria-label="'扫描目录 ' + connection.name" @click="scanDav(connection)">{{ davBusy[connection.id] === 'scan' ? '扫描中…' : '扫描' }}</AppleButton>
        </div>
        <p v-if="davStatus[connection.id] && davStatus[connection.id].kind !== 'idle'" class="apple-settings-connection-result" :class="davStatusClass(connection)" data-settings-dav-result role="status">{{ davStatusText(connection) }}</p>
      </article>
    </div>
    <p v-else-if="!davLoading && !davLoadError" class="apple-settings-connections-message" role="status">尚未添加 WebDAV 连接</p>
    <AppleButton variant="subtle" class="apple-settings-connection-add" :to="editorLocation(null, true)" data-settings-new-dav><template #leading><svg-icon icon-class="plus" /></template>添加 WebDAV 连接</AppleButton>
    <AppleButton ref="managementEntry" variant="plain" class="apple-settings-connections-manage" :to="editorLocation()">管理 WebDAV</AppleButton>
  </section>
</template>
<script>
import AppleWebDavSettings from './AppleWebDavSettings.vue';
import AppleButton from './ui/AppleButton.vue';
import './apple-settings-connections.scss';

export default {
  name: 'AppleSettingsConnections',
  extends: AppleWebDavSettings,
  components: { AppleButton },
  methods: {
    editorLocation(connection, create = false) {
      const query = { ...this.$route.query, section: 'webdav' };
      if (connection) query.connection = connection.id;
      else delete query.connection;
      if (create) query.create = '1';
      else delete query.create;
      return { path: '/settings', query };
    },
    focusManagement() { this.$refs.managementEntry?.$el?.focus({ preventScroll: true }); },
    async removeDav(connection) {
      if (this.davBusy[connection.id]) return;
      await AppleWebDavSettings.methods.removeDav.call(this, connection);
      if (!this.state.davConnections.some(item => item.id === connection.id)) {
        this.$nextTick(() => this.$el.querySelector('[data-settings-new-dav]')?.focus({ preventScroll: true }));
      }
    },
  },
};
</script>
